import axios from 'axios';

/**
 * Uploads a merchant logo via an API-issued presigned PUT URL and returns
 * the public URL to persist as the merchant's logoUrl. No AWS credentials
 * in the browser — the API's task role signs the upload URL.
 */
export const uploadToS3 = async (file: File): Promise<string> => {
  const { data } = await axios.post(
    `${import.meta.env.REACT_APP_API_URL}merchant/logo-upload-url`,
    { fileName: file.name, contentType: file.type }
  );

  // Plain fetch on purpose: the shared axios instance attaches the Firebase
  // Authorization header, which S3 rejects alongside a presigned signature.
  //
  // The presigned URL is signed with `status=pending` tagging, so the PUT
  // must echo that header or S3 rejects the signature. The object lands
  // pending; the create-location call confirms it once the merchant is saved.
  const response = await fetch(data.uploadUrl, {
    method: 'PUT',
    body: file,
    headers: {
      'Content-Type': file.type,
      'x-amz-tagging': 'status=pending',
    },
  });

  if (!response.ok) {
    throw new Error(`Logo upload failed with status ${response.status}`);
  }

  return data.publicUrl;
};
